import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { getLocalizedPath } = useLanguage();
  const { t } = useTranslation();

  const navigationLinks = [
    { nameKey: 'footer.links.home', path: '/' },
    { nameKey: 'footer.links.aboutUs', path: '/about-us' },
    { nameKey: 'footer.links.faqs', path: '/faqs' },
  ];

  const quickLinks = [
    { nameKey: 'footer.links.contact', path: '/contact' },
    { nameKey: 'footer.links.terms', path: '/terms' },
    { nameKey: 'footer.links.privacy', path: '/privacy' },
  ];

  const contactInfo = [
    {
      icon: 'phone',
      text: '+123-456-789',
    },
    {
      icon: 'email',
      text: 'example@grasy.com',
    },
    {
      icon: 'location',
      text: 'Address Line 01, Any City',
    },
  ];

  const socialLinks = [
    {
      name: 'Facebook',
      icon: 'facebook',
      href: '#',
    },
    {
      name: 'YouTube',
      icon: 'youtube',
      href: '#',
    },
    {
      name: 'Twitter',
      icon: 'twitter',
      href: '#',
    },
  ];

  const getIcon = (iconName) => {
    const icons = {
      phone: (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="24"
            height="24"
            transform="translate(0.570801 0.426758)"
            fill="white"
          />
          <path
            d="M7.1108 5.42676C7.1708 6.31676 7.3208 7.18676 7.5608 8.01676L6.3608 9.21676C5.9508 8.01676 5.6908 6.74676 5.6008 5.42676H7.1108ZM16.9708 17.4468C17.8208 17.6868 18.6908 17.8368 19.5708 17.8968V19.3868C18.2508 19.2968 16.9808 19.0368 15.7708 18.6368L16.9708 17.4468ZM8.0708 3.42676H4.5708C4.0208 3.42676 3.5708 3.87676 3.5708 4.42676C3.5708 13.8168 11.1808 21.4268 20.5708 21.4268C21.1208 21.4268 21.5708 20.9768 21.5708 20.4268V16.9368C21.5708 16.3868 21.1208 15.9368 20.5708 15.9368C19.3308 15.9368 18.1208 15.7368 17.0008 15.3668C16.9018 15.3298 16.7964 15.3128 16.6908 15.3168C16.4308 15.3168 16.1808 15.4168 15.9808 15.6068L13.7808 17.8068C10.9463 16.3571 8.64047 14.0513 7.1908 11.2168L9.3908 9.01676C9.6708 8.73676 9.7508 8.34676 9.6408 7.99676C9.26212 6.84465 9.0697 5.6395 9.0708 4.42676C9.0708 3.87676 8.6208 3.42676 8.0708 3.42676Z"
            fill="black"
          />
        </svg>
      ),
      email: (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="24"
            height="24"
            transform="translate(0.570801 0.796875)"
            fill="white"
          />
          <path
            d="M22.5708 6.79688C22.5708 5.69687 21.6708 4.79688 20.5708 4.79688H4.5708C3.4708 4.79688 2.5708 5.69687 2.5708 6.79688V18.7969C2.5708 19.8969 3.4708 20.7969 4.5708 20.7969H20.5708C21.6708 20.7969 22.5708 19.8969 22.5708 18.7969V6.79688ZM20.5708 6.79688L12.5708 11.7969L4.5708 6.79688H20.5708ZM20.5708 18.7969H4.5708V8.79688L12.5708 13.7969L20.5708 8.79688V18.7969Z"
            fill="black"
          />
        </svg>
      ),
      location: (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="24"
            height="24"
            transform="translate(0.570312 0.445312)"
            fill="white"
          />
          <path
            d="M21.5709 3.44531L15.0709 21.4453C15.027 21.5411 14.9566 21.6222 14.8679 21.6791C14.7793 21.7359 14.6762 21.7662 14.5709 21.7662C14.4656 21.7662 14.3625 21.7359 14.2738 21.6791C14.1852 21.6222 14.1147 21.5411 14.0709 21.4453L10.5709 14.4453L3.57087 10.9453C3.47513 10.9014 3.394 10.831 3.33712 10.7424C3.28024 10.6537 3.25 10.5506 3.25 10.4453C3.25 10.34 3.28024 10.2369 3.33712 10.1483C3.394 10.0596 3.47513 9.98919 3.57087 9.94531L21.5709 3.44531Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      facebook: (
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 0.25C4.02948 0.25 0 4.27948 0 9.25C0 14.2205 4.02948 18.25 9 18.25C13.9705 18.25 18 14.2205 18 9.25C18 4.27948 13.9705 0.25 9 0.25ZM12.0175 5.3593C12.0175 5.4934 11.9088 5.60212 11.7749 5.60212L10.7347 5.60248C10.0175 5.60248 9.88632 5.88202 9.88632 6.43246V7.5778H11.7023C11.7668 7.5778 11.8287 7.60336 11.8742 7.64908C11.9198 7.69462 11.9453 7.75636 11.9453 7.8208L11.9446 9.77848C11.9446 9.91258 11.8359 10.0213 11.7018 10.0213H9.88632V14.961C9.88632 15.0951 9.7776 15.2039 9.6435 15.2039H7.61796C7.48386 15.2039 7.37514 15.0951 7.37514 14.961V10.0211H5.82264C5.68854 10.0211 5.57982 9.9124 5.57982 9.7783V7.8208C5.57982 7.6867 5.68854 7.5778 5.82264 7.5778H7.37514V6.22672C7.37514 4.44652 8.49618 3.29632 10.231 3.29632L11.7752 3.29884C11.9092 3.29902 12.0177 3.40774 12.0177 3.54166L12.0175 5.3593Z"
            fill="black"
          />
        </svg>
      ),
      youtube: (
        <svg
          width="18"
          height="14"
          viewBox="0 0 18 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8207 3.64961C17.8207 3.64961 17.6449 2.40859 17.1035 1.86367C16.418 1.14648 15.6516 1.14297 15.3 1.10078C12.7828 0.917969 9.00352 0.917969 9.00352 0.917969H8.99648C8.99648 0.917969 5.21719 0.917969 2.7 1.10078C2.34844 1.14297 1.58203 1.14648 0.896484 1.86367C0.355078 2.40859 0.182812 3.64961 0.182812 3.64961C0.182812 3.64961 0 5.10859 0 6.56406V7.92812C0 9.38359 0.179297 10.8426 0.179297 10.8426C0.179297 10.8426 0.355078 12.0836 0.892969 12.6285C1.57852 13.3457 2.47852 13.3211 2.8793 13.3984C4.3207 13.5355 9 13.5777 9 13.5777C9 13.5777 12.7828 13.5707 15.3 13.3914C15.6516 13.3492 16.418 13.3457 17.1035 12.6285C17.6449 12.0836 17.8207 10.8426 17.8207 10.8426C17.8207 10.8426 18 9.38711 18 7.92812V6.56406C18 5.10859 17.8207 3.64961 17.8207 3.64961ZM7.14023 9.58398V4.525L12.0023 7.06328L7.14023 9.58398Z"
            fill="black"
          />
        </svg>
      ),
      twitter: (
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8901 2.62621C16.6981 2.11665 17.233 1.42115 17.495 0.536625C16.7571 0.946639 15.9653 1.24458 15.1442 1.42115C14.4412 0.644494 13.5512 0.25 12.4843 0.25C11.4414 0.25 10.5604 0.626002 9.84145 1.35746C9.49425 1.7048 9.21973 2.12132 9.03472 2.5815C8.84971 3.04168 8.7581 3.53582 8.76551 4.03365C8.76551 4.35109 8.80451 4.63463 8.88251 4.87503C5.80668 4.76716 3.26082 3.45629 1.25493 0.933172C0.914949 1.5506 0.744959 2.17932 0.744959 2.82962C0.744959 4.16617 1.29393 5.22534 2.38987 6.00303C1.7649 5.94858 1.21393 5.78627 0.744959 5.52019C0.744959 6.47457 1.01794 7.27178 1.56491 7.97344C2.09624 8.65717 2.84502 9.12674 3.6798 9.29972C3.36781 9.38191 3.03883 9.42095 2.70085 9.42095C2.38887 9.42095 2.16788 9.39424 2.03689 9.33568C2.26687 10.1134 2.70085 10.7441 3.32782 11.227C3.94762 11.7105 4.70156 11.9779 5.4797 11.9903C4.14777 13.0639 2.62485 13.595 0.90195 13.595C0.479973 13.595 0.18099 13.5888 0 13.5559C1.69691 14.6881 3.5858 15.25 5.67568 15.25C7.81457 15.25 9.70446 14.6932 11.3494 13.5796C12.9943 12.4721 14.2082 11.1058 14.9882 9.49697C15.7595 7.94027 16.1611 6.21807 16.1601 4.47129V3.9905C16.879 3.44594 17.5014 2.77837 18 2.017C17.3266 2.31684 16.6169 2.52176 15.8901 2.62621Z"
            fill="black"
          />
        </svg>
      ),
    };
    return icons[iconName] || null;
  };

  return (
    <footer className="bg-black text-white py-10 lg:pt-[42px] lg:pb-[25px] px-5 sm:px-6 xl:px-8">
      <div className="max-w-[1300px] mx-auto">
        <div className="flex items-center lg:items-start justify-between lg:flex-row flex-col gap-[60px] lg:gap-8">
          {/* Company Information */}
          <div className="max-w-[408px] w-full">
            <img
              src="/assets/logo-white.svg"
              alt="GK Distribution"
              className="mx-auto lg:mx-0"
            />
            <p className="text-white inter text-[16px] leading-[26px] font-medium lg:text-left text-center">
              {t('footer.description')}
            </p>

            {/* Newsletter Subscription */}
            <div className="space-y-2.5 my-6">
              <h3 className="text-white text-[16px] leading-[19px] inter font-semibold">
                {t('footer.subscribeTitle')}
              </h3>

              <div className="flex-1 flex items-center justify-between bg-[#E3E8EF] rounded-[10px] h-[46px]">
                <div className="flex-1 relative h-full">
                  <input
                    type="email"
                    placeholder={t('footer.emailPlaceholder')}
                    className="w-full h-full pl-[36px] pr-3 outline-none text-[14px] leading-[22px] font-medium inter bg-transparent text-black placeholder-[#97A3B6]"
                  />
                  <svg
                    className="absolute left-2.5 top-[12px] transform"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.8">
                      <path
                        d="M1.96484 6.67857L7.78176 10.5565C8.58365 11.0911 8.9846 11.3584 9.41796 11.4623C9.80094 11.554 10.2002 11.554 10.5832 11.4623C11.0165 11.3584 11.4175 11.0911 12.2194 10.5565L18.0363 6.67857M5.96485 16.5H14.0363C15.4364 16.5 16.1365 16.5 16.6712 16.2275C17.1417 15.9878 17.5241 15.6054 17.7638 15.135C18.0363 14.6002 18.0363 13.9001 18.0363 12.5V8C18.0363 6.59987 18.0363 5.8998 17.7638 5.36502C17.5241 4.89462 17.1417 4.51217 16.6712 4.27248C16.1365 4 15.4364 4 14.0363 4H5.96484C4.56471 4 3.86465 4 3.32987 4.27248C2.85946 4.51217 2.47701 4.89462 2.23733 5.36502C1.96484 5.8998 1.96484 6.59987 1.96484 8V12.5C1.96484 13.9001 1.96484 14.6002 2.23733 15.135C2.47701 15.6054 2.85946 15.9878 3.32987 16.2275C3.86465 16.5 4.56471 16.5 5.96485 16.5Z"
                        stroke="#97A3B6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                </div>
                <button className="px-3 h-full bg-white text-black rounded-r-[10px] text-[16px] leading-[26px] inter transition duration-200 font-medium">
                  {t('footer.subscribeBtn')}
                </button>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex items-center lg:justify-start justify-center gap-6">
              <h4 className="text-white text-[20px] leading-[28px] font-semibold dm-sans">
                {t('footer.followUs')}
              </h4>
              <div className="flex items-center gap-[11px]">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="w-[37px] h-[37px] bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition duration-200"
                  >
                    {getIcon(social.icon)}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation & Quick Link & Contact Info */}
          <div className="flex items-center sm:items-start max-w-[643px] w-full sm:text-left text-center justify-between sm:flex-row flex-col gap-[60px] sm:gap-8 xl:gap-10 lg:mt-10">
            <div className="space-y-[13px] sm:space-y-[21px]">
              <h3 className="text-white font-semibold inter text-[20px] leading-[28px]">
                {t('footer.navigation')}
              </h3>
              <ul className="space-y-[13px] sm:space-y-2.5">
                {navigationLinks.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={getLocalizedPath(link.path)}
                      className="text-white text-[16px] leading-[26px] font-medium inter hover:text-gray-300 transition duration-200"
                    >
                      {t(link.nameKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="space-y-[13px] sm:space-y-[21px]">
              <h3 className="text-white font-semibold inter text-[20px] leading-[28px]">
                {t('footer.quickLinks')}
              </h3>
              <ul className="space-y-[13px] sm:space-y-2.5">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={getLocalizedPath(link.path)}
                      className="text-white text-[16px] leading-[26px] font-medium inter hover:text-gray-300 transition duration-200"
                    >
                      {t(link.nameKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="space-y-[23px] sm:space-y-[21px]">
              <h3 className="text-white font-semibold inter text-[20px] leading-[28px]">
                {t('footer.contactInfo')}
              </h3>
              <div className="space-y-[23px] sm:space-y-[22px]">
                {contactInfo.map((contact, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center sm:justify-start gap-2"
                  >
                    {getIcon(contact.icon)}
                    <span className="text-white text-[16px] leading-[26px] font-medium inter hover:text-gray-300 transition duration-200">
                      {contact.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
